import { useState } from "react";
import {
  Appointments,
  AppointmentTooltip,
  DateNavigator,
  DayView,
  MonthView,
  Resources,
  Scheduler,
  TodayButton,
  Toolbar,
  ViewSwitcher,
  WeekView,
} from "@devexpress/dx-react-scheduler-material-ui";
import { ViewState } from "@devexpress/dx-react-scheduler";
import { GetAppointmentsResponseAppointments } from "../../../api/medical-operations";

const resources = [
  {
    fieldName: "type",
    title: "Type",
    instances: [
      { id: "Missed", text: "Missed", color: "#EC407A" },
      { id: "Canceled", text: "Canceled", color: "#64b5f6" },
      { id: "Closed", text: "Closed", color: "#4db6ac" },
      { id: "Scheduled", text: "Scheduled", color: "#7E57C2" },
      { id: "Pending Followup", text: "Pending Followup", color: "#FFD54F" },
    ],
  },
];
type Props = {
  appointments?: GetAppointmentsResponseAppointments[];
};
const CalendarScheduler = ({ appointments }: Props) => {
  const [viewName, setViewName] = useState<string>("Month");

  return (
    <Scheduler
      data={appointments?.map((appointment: GetAppointmentsResponseAppointments) => {
        const appointmentStart = new Date(appointment.DateFrom);
        const appointmentEnd = new Date(appointment.DateTo);

        const timezoneOffset = appointmentStart.getTimezoneOffset();
        appointmentStart.setMinutes(appointmentStart.getMinutes() + timezoneOffset);
        appointmentEnd.setMinutes(appointmentEnd.getMinutes() + timezoneOffset);

        return {
          title: appointment.PatientFirstName.concat(" ", appointment.PatientFamilyName),
          startDate: appointmentStart,
          endDate: appointmentEnd,
          status: appointment.Status,
          type: appointment.Status,
        };
      })}
    >
      <ViewState currentViewName={viewName} onCurrentViewNameChange={(viewName) => setViewName(viewName)} />
      <MonthView />
      <WeekView />
      <DayView />
      <Toolbar />
      <ViewSwitcher />
      <DateNavigator />
      <TodayButton />
      <Appointments />
      <AppointmentTooltip showCloseButton />
      <Resources data={resources} />
    </Scheduler>
  );
};

export default CalendarScheduler;
